export const SET_BOUQUET = "SET_BOUQUET";
export const SET_BALLOON = "SET_BALLOON";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRODUCT = "SET_PRODUCT";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const SET_CART = "SET_CART";
export const SET_LOADING = "SET_LOADING";
export const ALERT = "ALERT";
